import {useActions} from "../../../store/actions";
import {setProjectsAction} from "../../../store/actions/user";
import {getProjectsRequest} from "../../../services/api";

const useUpdateProjects = () => {
  const setProjects = useActions(setProjectsAction);
  return () => {
    return getProjectsRequest()
      .then(({data}) => setProjects(data));
  };
};

export default useUpdateProjects;